import * as errorReporter from './js/client/tracking/errorReporter';
import resolveRouteFromLocation from './js/client/client';
import { disableScrollRestoration } from './js/client/service/history';

errorReporter.initialise();
resolveRouteFromLocation();
disableScrollRestoration();
